import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiX, FiZap } from "react-icons/fi";
import { RenderMarkdownWithLatex } from "../../utils/utils";

const HintPopup = ({ isOpen, onClose, hintText }) => {
    // Hack na SSR (Next.js), żeby uniknąć błędu "document is not defined"
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) return null;

    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
                    {/* Backdrop */}
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                    />
                    
                    {/* Modal Content */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 20 }}
                        transition={{ type: "spring", duration: 0.35, bounce: 0 }}
                        className="relative bg-white rounded-2xl shadow-[0_8px_30px_-5px_rgba(35,56,85,0.15)] p-6 w-full max-w-sm border border-gray-100 z-10"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-3 right-3 p-2 bg-gray-50 rounded-full text-gray-400 hover:text-[#233855] transition-colors"
                            aria-label="Zamknij"
                        >
                            <FiX size={18} />
                        </button>

                        <div className="flex flex-col items-center text-center space-y-4">
                            <div className="p-3 rounded-xl bg-[#233855] shadow-md mb-2">
                                <FiZap size={28} className="text-[#F8AB3B]" />
                            </div>
                            
                            <h3 className="text-lg font-bold text-[#233855] font-apotek tracking-wide uppercase">
                                 Podpowiedź
                            </h3>
                            
                            {/* Scrollbar dla bardzo długich podpowiedzi, żeby nie wywaliło modala poza ekran */}
                            <div className="text-gray-600 text-sm leading-relaxed max-h-[60vh] overflow-y-auto custom-scrollbar px-1">
                                <RenderMarkdownWithLatex text={hintText} />
                            </div>

                            <button
                                onClick={onClose}
                                className="mt-4 bg-[#233855] text-white px-6 py-2 rounded-lg text-sm font-semibold tracking-wide hover:bg-[#345081] transition-colors w-full shadow-md active:scale-95 transform duration-100"
                            >
                                DZIĘKI!
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default HintPopup;